import { Estimation, ValidationFilter_2 } from "@/types/estimation.type";
import { GraphClientFilter } from "@/types/graphClient";

import { responseHandlerDefault } from "../utils/handler.util";
import axios from "./api";

export const getClientData = (validationFilter?: ValidationFilter_2) => {
  const params: { validationFilter?: ValidationFilter_2 } = {};
  if (validationFilter) {
    params.validationFilter = validationFilter;
  }
  return axios
    .post<ValidationFilter_2>("/clientdata/visualize", { validationFilter })
    .then(responseHandlerDefault);
};

export const getDatesWithDataClient = (samplingPointId: number, parameterClientId: number) => {
  return axios
    .get<Date[]>(
      `/clientdata/dates?samplingPoint=${samplingPointId}&parameter=${parameterClientId}`
    )
    .then(responseHandlerDefault);
};
